// // Use $ instead of jQuery without replacing global $
(function ($) {

})(jQuery);